// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"7732dac7","193":"066722aa"}[chunkId] + ".chunk.js";
};